// The studio's public contact address.
//
// Every mailto link and every "email us" line in the UI reads this, so moving
// the studio inbox is one build-time env var instead of a sweep through the
// copy. Set VITE_CONTACT_EMAIL at build time to change it:
//
//   VITE_CONTACT_EMAIL=hello@hddnlab.com npm run build
//
// The Contact tab prefers whatever an admin saved in the site_content "contact"
// section — which the API itself backfills from the server's CONTACT_EMAIL — so
// that address can also be changed at runtime with no rebuild. This constant is
// the fallback for that, and the single source for the rest of the copy.
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'hi@hddnlab.com';
